var exports = {
  "sectorWithSticky": "xcc377c0b--3c7b31--sectorWithSticky",
};

module.exports = exports;
